import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Creators } from './duck/actions';

import adTissot from '../../assets/images/ad-tissot.png';
import adSuggested from '../../assets/images/ad-suggested.png';
import adSeparator from '../../assets/images/ad-separator.png';
// import adShop from '../../assets/images/ad-shop.png';

// import Banner from '../common/Banner/Banner';
import AdBanner from '../common/AdBanner/AdBanner';

// import LatestBestOf from '../common/ListWithImage/List_Show_More';
import BestOfList from '../common/ListWithImage/List_Show_More';

import OuterBox from '../common/OuterBox/OuterBox';
import InnerBox from '../common/InnerBox/InnerBox';

// import adLinkedin from '../../assets/images/ad-linkedin.png';
import adAmazon from '../../assets/images/ad-amazon.png';
import adSuggestedVertical from '../../assets/images/ad-suggested-vertical.png';
import adAmazonVertical from '../../assets/images/ad-amazon-vertical.png';

import {
  // Title,
  // StyledLine,
  // StyledLineInside,
  ListElement,
  Image,
  FlexContainer
} from '../common/StyledComponents';
import { SideBar } from '../common/StyledComponents/StyledSideBar';
import List_XS_Image from '../common/ListWithImage/List_XS_Image';
// import List_S_Image from '../common/ListWithImage/List_S_Image';
import List_M_Image from '../common/ListWithImage/List_M_Image';
import Categories from './Categories';

class BestOf extends Component {
  componentWillMount = () => {
    // console.log('[BestOf.js] componentWillMount');
    window.scrollTo(0, 0);
  };

  componentDidMount = () => {
    // console.log('[Reviews.js] - CDM');
    // console.log('[News.js] componentDidMount');
    this.props.onFetchBestOfBanner();
    this.props.onFetchBestOfLatestReviews(1);

    this.props.onFetchTopReviews();
    // Fetch Laptops, Mobiles, Cameras, Accessories
    this.props.onFetchLaptops();
    this.props.onFetchMobiles();
    this.props.onFetchCameras();
    this.props.onFetchAccessories();
    // Fetch Best Of Laptops, Mobiles, Cameras, Accessories
    this.props.onFetchBestOfLaptops();
    this.props.onFetchBestOfMobiles();
    this.props.onFetchBestOfCameras();
    this.props.onFetchBestOfAccessories();
  };

  componentDidUpdate = (prevProps, prevState) => {
    // Make API requests according to the page that needs to be fetched.
  };

  handleLoadMore = () => {
    this.props.onFetchBestOfLatestReviews(this.props.pageForLatestReviews);
  };

  navigate = postSlug => {
    // console.log('postSlug: ', postSlug);
    this.props.history.push(`/${postSlug}`);
  };

  render() {
    return (
      <div className="News">
        <AdBanner height="250px" width="970px" margin="14px 0 0 0">
          <Image src={adTissot} width="100%" height="100%" alt="tissot ad" />
        </AdBanner>

        {/* {this.props.bestOfBannerData ? (
          <Banner
            bannerData={this.props.bestOfBannerData}
            clicked={this.navigate}
          />
        ) : null} */}

        <Categories />

        <OuterBox>
          <InnerBox>
            <FlexContainer direction="column">
              <BestOfList
                title="Best of Laptops/PC"
                fontsize="1.5rem"
                contentData={this.props.latestReviews}
                handleLoadMore={this.handleLoadMore}
                clicked={this.navigate}
                showMore="false"
              />

              <AdBanner height="91px" width="730px" margin="0 0 14px 0">
                <Image
                  src={adSeparator}
                  width="100%"
                  height="100%"
                  alt="tissot ad"
                />
              </AdBanner>

              <BestOfList
                className="BestOfList List_Show_More"
                title="Best Of Softwares"
                contentData={this.props.latestReviews}
                handleLoadMore={this.handleLoadMore}
                clicked={this.navigate}
                showMore="false"
              />

              <AdBanner height="91px" width="730px" margin="0 0 14px 0">
                <Image
                  src={adSeparator}
                  width="100%"
                  height="100%"
                  alt="tissot ad"
                />
              </AdBanner>

              {this.props.laptops ? (
                // eslint-disable-next-line
                <List_M_Image
                  className="List_M_Image mb3"
                  title="Best Alternatives"
                  fontsize="2.25rem"
                  fontfamily="Montserrat"
                  listItems={this.props.laptops}
                />
              ) : null}

              <AdBanner height="91px" width="730px" margin="0 0 14px 0">
                <Image
                  src={adSeparator}
                  width="100%"
                  height="100%"
                  alt="tissot ad"
                />
              </AdBanner>

              <BestOfList
                title="Best Of Mobile applications"
                fontsize="1.5rem"
                contentData={this.props.latestReviews}
                handleLoadMore={this.handleLoadMore}
                clicked={this.navigate}
                showMore="false"
              />
            </FlexContainer>

            <SideBar>
              <AdBanner height="250px" width="300px" margin="0 0 14px 0">
                <Image
                  src={adAmazon}
                  width="100%"
                  height="100%"
                  alt="tissot ad"
                />
              </AdBanner>

              {this.props.bestOfLaptops ? (
                // eslint-disable-next-line
                <List_XS_Image
                  className="List_XS_Image mb3"
                  title="Best of Laptops"
                  listItems={this.props.bestOfLaptops}
                />
              ) : null}

              <AdBanner height="250px" width="300px" margin="0 0 14px 0">
                <Image
                  src={adAmazon}
                  width="100%"
                  height="100%"
                  alt="tissot ad"
                />
              </AdBanner>

              <AdBanner height="565px" width="300px" margin="0.5rem 0">
                <Image
                  src={adSuggestedVertical}
                  width="100%"
                  height="100%"
                  alt="tissot ad"
                />
              </AdBanner>

              <AdBanner height="600px" width="300px" margin="18px 0 18px 0">
                <Image
                  src={adAmazonVertical}
                  width="100%"
                  height="100%"
                  alt="tissot ad"
                />
              </AdBanner>

              {/* {this.props.topReviews ? (
                // eslint-disable-next-line
                <List_S_Image
                  title="Top Reviews"
                  listItems={this.props.topReviews}
                />
              ) : null} */}

              <AdBanner height="250px" width="300px" margin="0 0 14px 0">
                <Image
                  src={adAmazon}
                  width="100%"
                  height="100%"
                  alt="tissot ad"
                />
              </AdBanner>
            </SideBar>
          </InnerBox>
        </OuterBox>

        <AdBanner height="250px" width="970px" margin="0">
          <Image src={adTissot} width="100%" height="100%" alt="tissot ad" />
        </AdBanner>

        <OuterBox>
          <InnerBox>
            <ListElement className="w-100" maxwidth="100%" padding="20px">
              {/* <Title
                fontFamily="Montserrat"
                fontSize="1.5rem"
                fontWeight="bold"
              >
                Suggested
              </Title>
              <StyledLine>
                <StyledLineInside />
              </StyledLine> */}
              {/* <AdBanner height="210px" width="1000px" margin="0"> */}
              <AdBanner height="346px" width="1040px" margin="0">
                <Image
                  src={adSuggested}
                  width="100%"
                  height="100%"
                  alt="tissot ad"
                />
              </AdBanner>
            </ListElement>
          </InnerBox>
        </OuterBox>
      </div>
    );
  }
}

const mapStateToProps = state => {
  // console.log('state: ', state);
  return {
    loading: state.news.loading,
    bestOfBannerData: state.reviews.bestOfBannerData,
    latestReviews: state.reviews.latestReviews,
    pageForLatestReviews: state.reviews.pageForLatestReviews,
    topReviews: state.reviews.topReviews,
    laptops: state.reviews.laptops,
    mobiles: state.reviews.mobiles,
    cameras: state.reviews.cameras,
    accessories: state.reviews.accessories,
    bestOfLaptops: state.reviews.bestOfLaptops,
    bestOfMobiles: state.reviews.bestOfMobiles,
    bestOfCameras: state.reviews.bestOfCameras,
    bestOfAccessories: state.reviews.bestOfAccessories
  };
};

const mapDispatchToProps = dispatch => ({
  onFetchBestOfBanner: () => dispatch(Creators.fetchBestOfBanner()),
  onFetchBestOfLatestReviews: page =>
    dispatch(Creators.fetchBestOfLatestReviews(page)),
  onFetchTopReviews: () => dispatch(Creators.fetchTopReviews()),
  onFetchLaptops: () => dispatch(Creators.fetchLaptops()),
  onFetchMobiles: () => dispatch(Creators.fetchMobiles()),
  onFetchCameras: () => dispatch(Creators.fetchCameras()),
  onFetchAccessories: () => dispatch(Creators.fetchAccessories()),
  onFetchBestOfLaptops: () => dispatch(Creators.fetchBestOfLaptops()),
  onFetchBestOfMobiles: () => dispatch(Creators.fetchBestOfMobiles()),
  onFetchBestOfCameras: () => dispatch(Creators.fetchBestOfCameras()),
  onFetchBestOfAccessories: () => dispatch(Creators.fetchBestOfAccessories())
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(BestOf);
